import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/xwitchLog'

export const xwitchLogService = {
    getItem,
    search,
    updateItem,
    depurate,
    searchDashboard,
    syncErrorType,
    syncPaymentMethod
};

function getItem(id) {
    return utilHelper.doIncognitoRequest(`xwitchLog/${id}`, 'GET')
}

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data : data, showAlert: false})
}

function searchDashboard(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/searchDashboard`, 'POST', { data : data, showAlert: false})
}

function depurate(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/depurate`, 'POST', { data : data, showAlert: false})
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//update
function syncErrorType() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncError`, 'POST', {});
}

function syncPaymentMethod() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncPaymentMethod`, 'POST', {});
}